import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useProductFlags } from '@modules/featureControl';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

const LOYALLIST_BANNER_KEY = 'PDP_FREESHIP_LOYALLIST';
const BEAUTY_BANNER_KEY = 'PDP_FREESHIP_BEAUTY';
const BANNER_KEY = 'PDP_FREESHIP';
/**
 * @param {boolean} isLoyalist
 * @param {boolean} isBeauty
 * @returns {LOYALLIST_BANNER_KEY | BEAUTY_BANNER_KEY | BANNER_KEY}
 */
const getBannerType = (isLoyalist, isBeauty) => {
  if (isLoyalist) {
    return LOYALLIST_BANNER_KEY;
  }
  if (isBeauty) {
    return BEAUTY_BANNER_KEY;
  }
  return BANNER_KEY;
};
/**
 * @returns {{ forceRerenderKey: import('vue').Ref<number>, banner: import('vue').ComputedRef<string> }}
 */
const useLoyalList = () => {
  const store = useStore();

  const forceRerenderKey = ref(0);
  const { bannerDetails } = useCommonProductGetters();
  const { beautyFlag } = useProductFlags();

  const tierName = computed(() => store.state.navLoyaltyStore?.rewardsData?.tierName);
  const bannerType = computed(() => getBannerType(tierName?.value, beautyFlag));
  const banner = computed(() => bannerDetails?.value[bannerType.value]?.[0].alt || '');

  // TODO Broken Vue reactivity for html content and v-html attribute. Doesn't update DOM with corresponding computed value
  onMounted(() => {
    forceRerenderKey.value += 1;
  });

  return {
    forceRerenderKey,
    banner,
  };
};

export default useLoyalList;
